import { useState, useEffect } from "react";

/**
 * useOnlineStatus Hook
 * 
 * Usage:
 *   const isOnline = useOnlineStatus();
 * 
 * Returns: true (online) | false (offline)
 */

export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const goOnline  = () => setIsOnline(true);
    const goOffline = () => setIsOnline(false);

    window.addEventListener("online",  goOnline);
    window.addEventListener("offline", goOffline);

    // Cleanup
    return () => {
      window.removeEventListener("online",  goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  return isOnline;
}